<!-- AI Generated Template -->
<page-header icon="fas fa-envelope" [header]="'Email addresses' | translate"
             [subHeader]="subheaderTranslation">
</page-header>

<mon-panel-next (onSearch)="onSearch($event)" [search]="search" [showSearch]="true">
    <tabs-extra>
        <csv-export-button [exports]="exports"></csv-export-button>
    </tabs-extra>
    <panel-body>
        <div class="mx-4">
            <table-container [collection]="emails" (onPageChange)="onPageChange($event)"
                             (onPerPageChange)="onPageSizeChange($event)"
                             [progress]="promise">
                <table class="table table-fixed table-hover table-vertial-align">
                    <thead>
                    <tr>
                        <th class="col-lg-28"
                            monTableSort
                            monSortBy="url"
                            [monStartAsc]="true"
                            [monSortDirection]="currentSort.direction"
                            [monCurrentlySortedBy]="currentSort.by"
                            (monOnSorted)="onMonTableSort($event)"
                        >
                            {{ 'Email' | translate }}
                        </th>
                        <th class="col-lg-8" *ngIf="showPolicy">
                            <span translate>Create as policy</span>
                            <span class="ml-1 fas fa-question-circle" aria-hidden="true"
                                  [ngbTooltip]="'Create a policy to make an email as unwanted content' | translate"
                                  triggers="focus hover"></span>
                        </th>
                        <th class="col-lg-6 text-right" *ngIf="scanDocuments"></th>
                        <th class="col-lg-6 text-right"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let email of emails; trackBy: trackByFn">
                        <td class="text-ellipsis" *ngIf="email.url !== ''">{{ email.url }}</td>
                        <td class="text-ellipsis text-italic" translate *ngIf="email.url == ''">Empty mailto</td>

                        <td *ngIf="showPolicy">
                            <button class="btn btn-border-radius btn-secondary"
                                    (click)="createEmailPolicy(email)">{{ 'Create as policy' | translate }}
                            </button>
                        </td>
                        <td class="text-right" *ngIf="scanDocuments">
                            <pages-button [text]="'Document' | translate"
                                          [textPlural]="'Documents' | translate"
                                          [ngModel]="email.documents_count"
                                          [monAriaLabel]="'Show documents with this email' | translate"
                                          (callback)="showPages(email, 'document')"></pages-button>
                        </td>
                        <td class="text-right">
                            <pages-button [ngModel]="email.html_pages_count"
                                          [monAriaLabel]="'Show pages with this email' | translate"
                                          (callback)="showPages(email, 'html')"></pages-button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </table-container>
        </div>
    </panel-body>
</mon-panel-next>
